// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.participants .sk-input__description {\n  min-height: 22px;\n}\n@media (min-width: 768px) {\n.participants .sk-input__description {\n    min-height: 52px;\n}\n}\n", ""]);
// Exports
module.exports = exports;
